import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
import { Apollo, QueryRef } from 'apollo-angular';
import { take, tap, pluck, withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';


// * QUERY FILTRO Inventario
const QUERY_clientes_registros = gql`
query ($entidad: inventario_fisicoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
  inventario_fisico {
    obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
      mensajes {
        codigo
        contexto
        texto
        tipo
      }
      respuesta {
        paginaActual
        cantidadRegistrosPorPagina
        totalPaginas
        totalRegistros
        registros {
          codigo
          rut_empresa
          sucursal_codigo
          rut_usuario_responsable
          bodega_codigo
          bodega_nombre
          estado_inventario_codigo
          estado_inventario_nombre
          fecha_creacion
          fecha_cierre
          observacion
          no_inventariado
        }
      }
    }
  }
}
        `

@Injectable({
  providedIn: 'root'
})
export class InventarioFisicoService {

  private clientesDataSubject = new BehaviorSubject(null);
  Clientess$ = this.clientesDataSubject.asObservable();
  postsQuery: QueryRef<any>;
  queryCliente: any;

  constructor(
    private gqlclient: GraphQLClient,
    private apollo: Apollo
      ) { }

       //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
   getInventarioFisico(inputParams): void {
    this.postsQuery = this.apollo.watchQuery<any>({
      query: QUERY_clientes_registros,
      variables: inputParams,
      fetchPolicy: 'network-only'
    })
    this.queryCliente = this.postsQuery.valueChanges.pipe(
      take(1),
     pluck('data', 'inventario_fisico'),
      withLatestFrom(this.Clientess$),
      tap(([apiResponse, respuesta]) => {
        return apiResponse.obtenerSegunFiltro.respuesta
      })
    )
  }

  obtenerSegunFiltro(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      listaBodega: number[],
      listaEstado: number[]
    },
    paginaActual: number,
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          inventario_fisico {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  rut_empresa
                  sucursal_codigo
                  rut_usuario_responsable
                  bodega_codigo
                  bodega_nombre
                  estado_inventario_codigo
                  estado_inventario_nombre
                  fecha_creacion
                  fecha_cierre
                  observacion
                  no_inventariado
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }

  guardarInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      rut_usuario_responsable: number,
      bodega_codigo: number,
      detalleInventarioFisico: [
        {
          producto_codigo: number,
          formato_codigo: string
        }
      ]
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            guardarInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  cantidad_diferencia
                  cantidad_saldo
                  fecha_registro
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.guardarInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerInventarFisico(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerInventarFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_contada
                  saldo_actual
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.obtenerInventarFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  guardaWorkInventarioProceso(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      codigo: number,
      rut_usuario_responsable: number,
      bodega_codigo: number,
      observacion: string,
      no_inventariado: boolean,
      detalleWorkInventario:
      {
        producto_codigo: number,
        formato_codigo: string,
        cantidad_contada: number
      }[]
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            guardaWorkInventarioProceso(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                observacion
                no_inventariado
                detalleWorkInventario {
                  empresa_rut
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  fecha_registro
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.guardaWorkInventarioProceso
        callback({ mensajes, respuesta })
      }
    );
  }

  excelDocInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            excelDocInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.excelDocInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  excelDocTomaInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            excelDocTomaInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.excelDocTomaInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }


  eliminarInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      codigo: number
      rut_usuario_responsable: number
      bodega_codigo: number
      fecha_creacion: Date
      detalleInventarioFisico: any[]
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            eliminarInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  cantidad_diferencia
                  cantidad_saldo
                  fecha_registro
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.eliminarInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  editarInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      codigo: number,
      rut_usuario_responsable: number,
      bodega_codigo: number,
      fecha_creacion: Date
      detalleInventarioFisico:
      {
        producto_codigo: number,
        formato_codigo: string
      }[]
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            editarInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  cantidad_diferencia
                  cantidad_saldo
                  fecha_registro
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.editarInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerTomaInventario(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerTomaInventario(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                estado_inventario_nombre
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico{
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                  precio_costo
                  valor_dif
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.obtenerTomaInventario
        callback({ mensajes, respuesta })
      }
    );
  }
  obtenerEditarAjusteFisico(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerEditarAjusteFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                estado_inventario_nombre
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico{
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                  precio_costo
                  valor_dif
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.obtenerEditarAjusteFisico
        callback({ mensajes, respuesta })
      }
    );
  }
  modificarWorkInventarioProceso(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      codigo: number,
      rut_usuario_responsable: number,
      bodega_codigo: number,
      observacion: string,
      no_inventariado: boolean,
      detalleWorkInventario:
      {
        producto_codigo: number,
        formato_codigo: string,
        cantidad_contada: number
      }[]
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            modificarWorkInventarioProceso(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                observacion
                no_inventariado
                detalleWorkInventario {
                  empresa_rut
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  fecha_registro
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.modificarWorkInventarioProceso
        callback({ mensajes, respuesta })
      }
    );
  }
  guardarAjusteInventarioFisico(inputParams: {
    entidad: {
      codigo: number
      rut_empresa: number
      sucursal_codigo: number
      rut_usuario_responsable: number
      bodega_codigo: number
      bodega_nombre: string
      estado_inventario_codigo: number
      fecha_creacion: Date
      observacion: string
      no_inventariado: boolean
      detalleInventarioFisico: {
          seleccion: boolean,
          rut_empresa: number
          sucursal_codigo: number
          inventario_fisico_codigo: number
          producto_codigo: number
          sku: string
          producto_nombre: string
          formato_codigo: string
          formato_nombre: string
          bodega_codigo: number
          bodega_nombre: string
          rubro_codigo: number
          rubro_nombre: string
          familia_codigo: number
          familia_nombre: string
          fecha_registro: string
          cantidad_saldo: number
          cantidad_contada: number
          cantidad_diferencia: number
        }[]
    }
  }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            guardarAjusteInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.guardarAjusteInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerConsultaInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerConsultaInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                estado_inventario_nombre
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                  cant_ent
                  cant_sal
                  precio_costo
                  valor_dif
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.obtenerConsultaInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerConsultaInventarioFisicoExcel(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      codigo: number
      retornaExcel: boolean
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerConsultaInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
               rutaArchivo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico.obtenerConsultaInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

}
